<template>
  <div class="page events">
    <popup
      @closePopup="closePopup"
      title="Ticket Description"
      :show="showPopup"
    >
      <editor
        :inputData="selectedTicket.description"
        @updateData="updateTicketDescription"
      />
      <div class="btns">
        <button @click="saveTixDescription" class="btn">Save</button>
        <button @click="closePopup" class="btn">Close</button>
      </div>
    </popup>
    <popup title="Add A Venue" :show="showVenuePopup">
      <gAutoComplete
        :inputAddress="venue"
        @autoCompleteAddress="updateAddress($event, 'venue')"
      >
        <div class="input">
          <label>Name <span>*</span></label>
          <input type="text" v-model="venue.name" />
        </div>
        <div class="input">
          <label>Area<span>*</span></label>
          <input type="text" v-model="venue.area" />
        </div>
      </gAutoComplete>
      <div class="btns">
        <button @click="closePopup" class="btn text_btn">Cancel</button>
        <button @click="addVenue" class="btn">Save</button>
        <div v-if="error" class="error">
          {{ error }}
        </div>
      </div>
    </popup>
    <btn-nav>
      <!-- <button @click='goTo("event", "event")' class='btn text_btn'><img src='@/assets/img/eye.svg'>Preview</button> -->
      <button @click="saveEvent()" class="btn">Save</button>
      <button @click="saveEvent()" class="btn">Publish</button>
    </btn-nav>

    <div class="contain">
      <h1>Create An Event</h1>

      <card title="Event Details">
        <div class="inputs">
          <div class="input">
            <label>Event Title <span class="required">*</span></label>
            <input
              type="text"
              placeholder="Create An Event"
              v-model="event.title"
            />
          </div>
          <div class="input">
            <label>Event Slug <span class="required">*</span></label>
            <input type="text" v-model="event.slug" />
          </div>
          <div class="input full">
            <label>Event Description <span class="required">*</span></label>
            <textarea v-model="event.description"></textarea>
          </div>
          <div class="input">
            <label>Start Date <span class="required">*</span></label>
            <input
              @click="$refs.start_time.isOpen = true"
              type="text"
              readonly
              :value="start_time"
            />
            <datetime
              hidden
              ref="start_time"
              type="datetime"
              v-model="start_time"
            ></datetime>
          </div>
          <div class="input">
            <label>End Date <span class="required">*</span></label>
            <input
              @click="$refs.end_time.isOpen = true"
              type="text"
              readonly
              :value="end_time"
            />
            <datetime
              hidden
              ref="end_time"
              type="datetime"
              v-model="end_time"
            ></datetime>
          </div>
          <div class="input">
            <label>Event Contact Email <span class="required">*</span></label>
            <input type="text" v-model="event.contact_info.email" />
          </div>
          <div class="input">
            <label>Event Contact Number <span class="required">*</span></label>
            <input
              type="tel"
              v-model="event.contact_info.phone"
              @input="acceptNumber"
            />
          </div>
          <div class="input">
            <label>Event Tags <span class="required">*</span></label>
            <input ref="tags" type="text" @change="addTags" />
            <div>
              <ul>
                <li v-for="(tag, i) in event.tags" :key="i">
                  {{ tag }}
                  <span
                    ><img
                      @click="removeTag(i)"
                      style="width: 30px"
                      src="@/assets/img/trash.svg"
                  /></span>
                </li>
              </ul>
            </div>
          </div>
          <div class="input"></div>
          <div class="input">
            <label>Event Banner <span class="required">*</span></label>
            <upload
              title="an Event Image"
              :media="event.event_image"
              @addMedia="addMedia($event, 'event_image')"
              @removeImage="event.event_image = null"
            ></upload>
          </div>
          <div class="input">
            <label>Event Logo <span class="required">*</span></label>
            <upload
              title="an Event Logo"
              :media="event.logo"
              @addMedia="addMedia($event, 'logo')"
              @removeImage="event.logo = null"
            ></upload>
          </div>
          <div class="input">
            <label>Public Event <span class="required">*</span></label>
            <switch-toggle
              v-model="event.private"
              :color="{
                checked: '#FBA500',
                unchecked: '#FBA500',
                disabled: '#FBA500',
              }"
              switch-color="white"
              :width="80"
              :sync="true"
              :labels="{ checked: 'Public', unchecked: 'Private' }"
            />
          </div>
          <div class="input">
            <label>Digital Checkin <span class="required">*</span></label>
            <switch-toggle
              v-model="event.digital_check_in"
              :color="{
                checked: '#FBA500',
                unchecked: '#fb2700',
                disabled: 'white',
              }"
              switch-color="white"
              :width="60"
              :sync="true"
              :labels="{ checked: 'Yes', unchecked: 'No' }"
            />
          </div>
        </div>
      </card>

      <!-- <card title="Event Location">
        <div class="inputs">
          <div class="input">
            <label>Address 1 <span class="required">*</span></label>
            <input type="text" v-model="event.address.address_1" />
          </div>
          <div class="input">
            <label>Address 2</label>
            <input type="text" v-model="event.address.address_2" />
          </div>
          <div class="input">
            <label>Address 3</label>
            <input type="text" v-model="event.address.address_2" />
          </div>
          <div class="input">
            <label>Zip Code <span class="required">*</span></label>
            <input type="text" v-model="event.address.zip" />
          </div>
          <div class="input">
            <label>City <span class="required">*</span></label>
            <input type="text" v-model="event.address.city" />
          </div>
          <div class="input">
            <label>State <span class="required">*</span></label>
            <input type="text" v-model="event.address.state" />
          </div>
          <div class="input">
            <label>Country <span class="required">*</span></label>
            <input type="text" v-model="event.address.country" />
          </div>
        </div>
      </card> -->

      <!-- <card title="Event Location">
        <div class="inputs">
          <div class="input full">
            <label>Select A Venue (Optional)</label>
            <v-select
              v-if="venues.length"
              label="name"
              :options="venues"
              v-model="selectedVenue"
            >
            </v-select>
            <div v-else>
              <p>You currently don't have any venues saved</p>
              <button class="btn" @click="openVenuePopup">Add Venue</button>
            </div>
          </div>
        </div>
        <gAutoComplete
          :inputAddress="event.address"
          :showMap="true"
          @autoCompleteAddress="updateAddress($event, 'event')"
        ></gAutoComplete>
      </card> -->

      <card title="Additional Information">
        <div class="inputs">
          <div class="input full">
            <label>Listing Privacy</label>
            <radio v-model="event.private" :value="false"
              ><span>Public Page:</span> Discoverable by anyone on Journey, our
              distribution partners, and search engines.</radio
            >
            <radio v-model="event.private" :value="true"
              ><span>Private Page:</span> Accessible only by people you
              specify.</radio
            >
          </div>
          <div class="input">
            <label>Event Type</label>
            <v-select v-model="event.event_type"></v-select>
          </div>
          <div class="input">
            <label>Event Topic</label>
            <v-select v-model="event.event_topic"></v-select>
          </div>
          <div class="input full">
            <check :value="true" v-model="event.remaining"
              >Show the number of remaining tickets on your event listing</check
            >
          </div>
        </div>
      </card>

      <!-- <card title="Event Tickets">
        <p>What type of ticket would you like to start with?</p>
        <div class="ticket_btns btns">
          <button @click="addTicket('free')" class="btn">
            <img class="white_icon" src="@/assets/img/plus.svg" />Free Ticket
          </button>
          <button @click="addTicket('paid')" class="btn">
            <img class="white_icon" src="@/assets/img/plus.svg" />Paid Ticket
          </button>
          <button @click="addTicket('donate')" class="btn">
            <img class="white_icon" src="@/assets/img/plus.svg" />Donation
            Ticket
          </button>
        </div>
        <table v-if="tickets.length">
          <thead>
            <td>Ticket Name</td>
            <td>Quantity Available</td>
            <td>Price</td>
            <td>Action</td>
          </thead>

          <tbody>
            <tr v-for="(ticket, index) in tickets" :key="index">
              <td>
                <input
                  type="text"
                  placeholder="i.e Early Bird"
                  v-model="ticket.name"
                />
              </td>
              <td>
                <input
                  type="number"
                  min="1"
                  v-model.number="ticket.quantity"
                  @input="ticket.amount_available = ticket.quantity"
                />
              </td>
              <td>
                <template v-if="ticket.type == 'paid'">
                  <p class="price_tag">$</p>
                  <input
                    type="number"
                    class="price"
                    min="0"
                    v-model.number="ticket.price"
                    @input="formatPrice($event, ticket)"
                  />
                </template>
                <p v-if="ticket.type == 'free'">Free</p>
                <p v-if="ticket.type == 'donate'">Donation</p>
              </td>
              <td class="icons">
                <div class="img settings">
                  <img
                    @click="openPopup(ticket)"
                    src="@/assets/img/description.svg"
                  />
                </div>
                <div class="img trash">
                  <img
                    class="trash"
                    @click="deleteTicket(ticket)"
                    src="@/assets/img/trash.svg"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tix_error" v-if="!tickets.length">
          <p>No tickets have been added.</p>
        </div>
      </card> -->

      <card title="Event Payment">
        <div class="inputs">
          <div class="input">
            <label
              >What country will you be paid
              <span class="required">*</span></label
            >
            <input type="text" v-model="payment.country" />
          </div>
          <div class="input">
            <label>Currency <span class="required">*</span></label>
            <input type="text" v-model="payment.currency" />
            <p class="small_cta">My currency isn't listed</p>
          </div>
          <div class="input full">
            <label>Tax Options</label>
            <button class="btn">
              <img class="white_icon" src="@/assets/img/plus.svg" />Add Sales
              Tax
            </button>
          </div>
          <div class="input full">
            <label>Refund Policy</label>
            <radio v-model.number="event.refund_period" :value="1"
              ><span>1 day:</span> Attendees can receive refunds up to 1 day
              before your event start date.</radio
            >
            <radio v-model.number="event.refund_period" :value="7"
              ><span>7 day:</span> Attendees can receive refunds up to 7 day
              before your event start date.</radio
            >
            <radio v-model.number="event.refund_period" :value="30"
              ><span>30 day:</span> Attendees can receive refunds up to 30 day
              before your event start date.</radio
            >
            <radio v-model="event.refund_period" value="undefined"
              ><span>Undefined:</span> I will respond to attendee refund
              requests on a case by case basis.</radio
            >
            <radio v-model.number="event.refund_period" :value="0"
              ><span>No refunds:</span> No refunds at any time.</radio
            >
            <p>
              Journey's fee is nonrefundable and won't be included in refunds.
              <span class="small_cta">Learn More</span>
            </p>
          </div>
        </div>
      </card>

      <!-- <card title='Additional Information'>
            <p>Do you have a general information for the users</p>
            <button class='btn'>Add </button>
            <div class='inputs'>
                <div class='input'>
                    <label>Address 1 <span class="required">*</span></label>
                    <input type='text' v-model='event.address.address_1' />
                </div>
            </div>
        </card> -->
    </div>

    <div class="save">
      <div class="contain">
        <h2>Save your new event!</h2>
        <div class="btns">
          <button @click="saveEvent()" class="btn dark_btn white_btn">
            Save
          </button>
          <button @click="saveEvent()" class="btn line_btn">Publish</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import Card from "@/components/Section.vue";
import Upload from "@/components/Upload.vue";
import PrettyRadio from "pretty-checkbox-vue/radio";
import PrettyCheck from "pretty-checkbox-vue/check";
import GoogleAddress from "@/components/Tools/GoogleAddress.vue";
import Popup from "@/components/Popup.vue";
import CKEditor from "@/components/Tools/CKEditor.vue";
import { Datetime } from "vue-datetime";
import { ToggleButton } from "vue-js-toggle-button";
import "vue-datetime/dist/vue-datetime.css";
import Swal from "sweetalert2";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    card: Card,
    datetime: Datetime,
    "switch-toggle": ToggleButton,
    upload: Upload,
    radio: PrettyRadio,
    check: PrettyCheck,
    gAutoComplete: GoogleAddress,
    popup: Popup,
    editor: CKEditor,
  },
  data() {
    return {
      error: null,
      image: null,
      logo: null,
      refundPolicy: "30 day",
      additional: {
        public: true,
        event_type: null,
        event_topic: null,
        remaining: false,
      },
      payment: {
        country: "United States",
        currency: "USD",
      },
      tickets: [],
      event: {
        created_at: Date.now(),
        logo: null,
        template_id: 1,
        tags: [],
        image: null,
        title: null,
        slug: null,
        private: true,
        status: "DRAFT",
        description: null,
        digital_check_in: false,
        contact_info: {
          email: null,
          phone: null,
        },
        address: {
          address_1: null,
          address_2: null,
          address_3: null,
          zip: null,
          city: null,
          state: null,
          country: null,
          map: null,
        },
        start_time: 0,
        end_time: 0,
      },
      venues: [],
      selectedVenue: null,
      selectedTicket: {},
      showPopup: false,
      venue: {
        address_1: null,
        address_2: null,
        address_3: null,
        zip: null,
        city: null,
        state: null,
        country: null,
        map: null,
      },
      showVenuePopup: false,
    };
  },
  firestore() {
    return {
      tickets: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("ticket"),
      venues: db
        .collection("user")
        .doc(auth.currentUser.uid)
        .collection("venues"),
    };
  },
  created() {
    this.getEvent();
  },
  computed: {
    start_time: {
      get() {
        return this.event.start_time
          ? moment(this.event.start_time).format("MM/DD/YYYY hh:mm a")
          : null;
      },
      set(timestring) {
        this.event.start_time = new Date(timestring).valueOf();
      },
    },
    end_time: {
      get() {
        return this.event.end_time
          ? moment(this.event.end_time).format("MM/DD/YYYY hh:mm a")
          : null;
      },
      set(timestring) {
        this.event.end_time = new Date(timestring).valueOf();
      },
    },
  },

  methods: {
    updateAddress(data, key) {
      if (key == "venue") {
        return (this.venue = data);
      }
      this.event.address = data;
    },
    addTags(e) {
      let tag = e.target.value;
      this.event.tags.push(tag);
      this.$refs.tags.value = null;
    },
    removeTag(i) {
      this.event.tags.splice(i, 1);
    },
    validate() {
      let valid = true;
      let event = this.event;
      for (let key in event) {
        if (
          key == "title" ||
          key == "logo" ||
          key == "description" ||
          key == "start_time" ||
          key == "end_time" ||
          key == "tags" ||
          key == "event_type"
        ) {
          if (!event[key]) valid = false;
        } else if (key == "contact_info") {
          for (let subkey in event[key]) {
            if (subkey == "phone" || subkey == "email") {
              if (!event[key][subkey]) valid = false;
            }
          }
        }
      }

      return valid;
    },
    getEvent() {
      db.collection("event")
        .doc(this.$route.params.id)
        .get()
        .then((snapshot) => {
          if (snapshot.exists) {
            this.event = snapshot.data();
          }
        });
    },
    addMedia(url, key) {
      this.event[key] = url;
    },
    saveEvent() {
      // validate Form

      if (this.validate()) {
        this.saveInfo();
      } else {
        Swal.fire(
          "Missing Fields",
          "Please fill in all required fields",
          "warning"
        );
      }
    },
    saveInfo() {
      let event = this.event;
      event.start_time = new Date(event.start_time).getTime();
      event.end_time = new Date(event.end_time).getTime();
      event.user_id = auth.currentUser.uid;
      db.collection("event")
        .doc(this.$route.params.id)
        .set(event, { merge: true })
        .then(() => {
          if (this.tickets.length) this.saveTicketsToEvent();
        })
        .then(() => {
          this.saveEventToUser();
        });
    },
    saveTicketsToEvent() {
      let batch = db.batch();
      let last_index = this.tickets.length - 1;
      this.tickets.forEach(async (ticket, index) => {
        let ref = db
          .collection("event")
          .doc(this.$route.params.id)
          .collection("ticket")
          .doc(ticket.ticket_id);
        await batch.set(ref, ticket, { merge: true });
        if (index == last_index) {
          await batch.commit();
        }
      });
    },
    saveEventToUser() {
      let data = {
        access: {
          superadmin: true,
          admin: true,
          exhibitor: true,
          attendee: true,
        },
        title: this.event.title,
        status: this.event.status ? this.event.status : 'DRAFT' ,
        logo: this.event.logo,
        start_time: new Date(this.event.start_time).getTime(),
        end_time: new Date(this.event.end_time).getTime(),
      };
      return db
        .collection("user")
        .doc(auth.currentUser.uid)
        .collection("event")
        .doc(this.$route.params.id)
        .set(data, { merge: true })
        .then(() => {
          this.goTo("/event/" + this.$route.params.id + "/management");
        });
    },
    acceptNumber() {
      var x = this.event.contact_info.phone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.event.contact_info.phone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    addTicket(type) {
      let new_ticket_ref = db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("ticket")
        .doc();

      let ticket = {
        description: type,
        ticket_id: new_ticket_ref.id,
        type: type,
        accept_donation: type == "donate" ? true : false,
        amount_available: 0,
        price: 0,
        name: null,
      };
      this.tickets.unshift(ticket);
    },
    formatPrice(event, ticket) {
      let val = event.target.value;
      let price = parseInt(val);
      ticket.price = price;
    },
    deleteTicket(ticket) {
      db.collection("event")
        .doc(this.$route.params.id)
        .collection("ticket")
        .doc(ticket.ticket_id)
        .delete();

      this.tickets = this.tickets.filter(
        (t, i) => t.ticket_id !== ticket.ticket_id
      );
    },
    openPopup(ticket) {
      this.selectedTicket = ticket;
      this.showPopup = true;
    },
    closePopup() {
      this.selectedTicket = {};
      this.showPopup = false;
      this.closeVenuePopup();
    },
    openVenuePopup() {
      this.showVenuePopup = true;
      this.venue.id = db
        .collection("user")
        .doc(auth.currentUser.uid)
        .collection("venues")
        .doc().id;
    },
    closeVenuePopup() {
      this.showVenuePopup = false;
      this.venue = {
        name: null,
        area: null,
        address_1: null,
        address_2: null,
        address_3: null,
        zip: null,
        city: null,
        state: null,
        country: null,
        map: null,
      };
    },
    validInputs() {
      if (
        !this.venue.name ||
        !this.venue.address_1 ||
        !this.venue.city ||
        !this.venue.state ||
        !this.venue.country ||
        !this.venue.zip
      ) {
        return false;
      }
      return true;
    },
    addVenue() {
      if (!this.validInputs()) {
        this.error = "Missing required fields.";
        setTimeout(() => {
          this.error = null;
        }, 3000);
        return;
      }
      db.collection("user")
        .doc(auth.currentUser.uid)
        .collection("venues")
        .doc(this.venue.id)
        .set(this.venue, { merge: true })
        .then(() => {
          this.closeVenuePopup();
        });
    },
    updateTicketDescription(payload) {
      this.selectedTicket.description = payload;
    },
    saveTixDescription() {
      this.tickets.forEach((ticket) => {
        if (ticket.ticket_id == this.selectedTicket.ticket_id) {
          ticket.description = this.selectedTicket.description;
          return null;
        }
      });
      this.selectedTicket = {};
      this.showPopup = false;
    },
  },
  watch: {
    event: {
      handler: function (val, oldVal) {
        this.event.slug = this.event.title.split(" ").join("-");
      },
      deep: true,
    },
    image() {
      this.event.image = this.image;
    },
    logo() {
      this.event.logo = this.logo;
    },
    selectedVenue() {
      if (this.selectedVenue) {
        this.event.address = this.selectedVenue;
      }
    },
  },
};
</script>

<style lang="scss">
.popup {
  .inputs {
    height: 345px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px 30px 10px;
  }
  .input {
    width: 48%;
    input {
      padding: 10px !important;
    }
  }
  .error {
    font-weight: bold;
    color: red;
  }
}
.events {
  background: white;

  .save {
    background: #fba500;
    padding: 30px 0;

    h2 {
      font-size: 30px;
      color: white;
    }

    .btns {
      display: flex;
      flex-wrap: wrap;
    }

    .btns .btn {
      margin-right: 30px;
    }
  }

  .ticket_btns.btns {
    display: flex;
    flex-wrap: wrap;
    .btn {
      display: flex;
      align-items: center;
      margin-right: 20px;
    }
    img {
      height: 20px;
      margin-right: 10px;
    }
  }

  .tix_error {
    margin-top: 30px;
    font-size: 20px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 30px;

    td {
      width: 150px;

      &:first-child {
        width: auto;
      }

      p {
        margin: 0;
      }
    }

    thead {
      background-color: #dedede;

      td {
        padding: 10px;
      }
    }

    tbody {
      td {
        padding: 20px 10px;
        border-bottom: 1px solid #eaeaea;
        background-color: transparent;
        position: relative;

        .price_tag {
          position: absolute;
          margin: 0;
          z-index: 2;
          left: 20px;
          top: 50%;
          transform: translateY(-50%);
        }

        .price {
          padding-left: 25px;
          position: relative;
        }
      }

      tr {
        background-color: transparent;
      }
    }

    .icons {
      display: flex;
      .img {
        border-radius: 100%;
        height: 35px;
        width: 35px;
        background: white;
        box-shadow: 0 0 8px rgba(128, 128, 128, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 10px;
        &.settings {
          background: #fba500;
        }
        &.trash {
          background: #f42702;
        }
        img {
          height: 20px;
          filter: brightness(0) invert(1);
        }
      }
    }
  }
}

@import "~pretty-checkbox/src/pretty-checkbox.scss";
.pretty {
  margin-bottom: 5px;
  .state label {
    display: flex;
    align-items: center;
    opacity: 1 !important;

    span {
      font-weight: bold;
      color: #0d0d0d !important;
      margin-right: 5px;
      margin-left: -15px;
    }
  }
  &:before {
    background: white;
    opacity: 1;
  }
}

.pretty .state label:before {
  background-color: white;
  border: none;
  box-shadow: 0 0 8px rgba(128, 128, 128, 0.2);
  top: auto;
  position: relative;
  margin-right: 10px;
}
.pretty.p-default input:checked ~ .state label:after {
  background-color: #fba500 !important;
  top: auto;
}
</style>
